<div class="htst-info-container">
  <div class="header-info">
    <div>
      <i nz-icon nzType="icon" class="svg-icon big-icon"></i>
    </div>
    <div class="body-bold">{{ sensorType() }}</div>
  </div>
  <div class="htst-info-box">
    <div class="body-bold-cap">{{ gatewayLabel() }}</div>
    <div class="info-slate">{{ htstInfo().gatewayId }}</div>
  </div>
  <div class="htst-info-box">
    <div class="body-bold-cap">{{ macAddressLabel() }}</div>
    <div class="info-slate">{{ htstInfo().macAddress }}</div>
  </div>
  <div class="htst-info-box">
    <div class="body-bold-cap">{{ dauModelLabel() }}</div>
    <div class="info-slate">{{ htstInfo().dauModel }}</div>
  </div>
  <div class="htst-info-box">
    <div class="body-bold-cap">{{ sensorColorLabel() }}</div>
    <div
      class="info-slate color-box"
      [style.background-color]="htstInfo().sensorColor"
    ></div>
  </div>
</div>
